export const proposalsApi = {
  getProposals: (
    client,
    {
      repId,
      page = 1,
      limit = 10,
      status,
      search,
      startDate,
      endDate,
      sort,
    } = {},
  ) => {
    const params = new URLSearchParams()
    if (repId) params.set('repId', repId)
    if (status) params.set('status', status)
    params.set('page', String(page))
    params.set('limit', String(limit))
    if (search) params.set('searchTerm', search)
    if (startDate) params.set('startDate', startDate)
    if (endDate) params.set('endDate', endDate)
    if (sort && sort.length > 0) {
      sort.forEach((s, i) => {
        params.set(`sort[${i}][column]`, s.column)
        params.set(`sort[${i}][direction]`, s.direction)
      })
    }
    return client(`proposals?${params.toString()}`, {method: 'GET'})
  },

  getProposalById: (client, proposalId) =>
    client(`proposals/${proposalId}`, {method: 'GET'}),

  deleteProposal: (client, proposalId) =>
    client(`proposals/${proposalId}`, {method: 'DELETE'}),

  duplicateProposal: (client, proposalId, data = {}) => {
    const body = {}
    if (data.businessName) body.businessName = data.businessName
    if (data.clientType) body.clientType = data.clientType
    if (data.clientEmail) body.clientEmail = data.clientEmail
    if (data.clientPhone) body.clientPhone = data.clientPhone
    if (data.thryvId) body.thryvId = data.thryvId
    return client(`proposals/${proposalId}/duplicate`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      ...(Object.keys(body).length > 0 && {
        body: JSON.stringify(body),
      }),
    })
  },
}
